export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.10-1200.56",
  commitId: "06c183cdd8c6e72b379d8c8a6c95be1f5a8faaea",
  commitTime: "2026-06-10T12:00:56.000Z",
});
